import { create } from "zustand";
import { persist } from "zustand/middleware";
import { customStorage } from "../utils/index";
import {
  getCompaniesList,
  getInviteOnlyCompaniesList,
} from "../utils/companyUtils";

const useCompaniesStore = create()(
  persist(
    (set) => ({
      isCompaniesListLoading: false,
      isInviteOnlyCompaniesListLoading: false,
      companiesList: [],
      forInviteOnlyCompaniesList: [],
      pagination: { limit: 10, page: 1, totalCount: 0, totalPages: 0 },

      fetchAllCompanies: async (payload) => {
        await getCompaniesList(payload, set); // Call the utility function and pass `set` to update state
      },
      fetchInviteOnlyCompanies: async (payload) => {
        await getInviteOnlyCompaniesList(payload, set); // Call the utility function and pass `set` to update state
      },
      updateCompanyStatusLocally: (companyId, isActive) =>
        set((state) => ({
          companiesList: state.companiesList.map((company) =>
            company?.id === companyId
              ? { ...company, is_active: isActive }
              : company
          ),
        })),
    }),
    {
      name: "company-storage", // Store name for persistence (localStorage)
      storage: customStorage, // Use custom localStorage (or sessionStorage)
    }
  )
);

export default useCompaniesStore;
